<ng-container
    *ngIf="!hasOnlyOneCompany && !dropdownEnabled">
    <div class="input-container">
        <div class="input-group">
            <input style="height: fit-content; width: 200px" #searchField
                type="text" class="form-control bgnone"
                [placeholder]="'organization.all' | translate | capitalize"
                [resultFormatter]="resultFormatter" [inputFormatter]="inputFormatter" [ngbTypeahead]="search"
                (selectItem)="updateSelectedCompanyBySearch($event.item)"
                [value]="selectedCompanyDisplay" (focusout)="cancelSearch()"
                (keyup)='updateSearchText($event.target);'>

            <span class="input-group-text" role="button" (click)="resetSearch()"
                [title]="'Commands.remove' | translate"
                *ngIf="selectedCompanyDisplay">
                <i class="far fa-fw fa-times"></i>
            </span>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="dropdownEnabled">
    <lib-select #selectdropdown style="height: 40px; width: 300px" (itemChange)="updateSelectedCompany($event)" *ngIf="companies"
        [(item)]="selectedCompanyGuid">
        <option [value]="undefined">{{'organization.all' | translate |
            capitalize}}</option>
        <option *ngFor="let company of companies.results"
            [value]="company.guid">
            {{company.searchName}}
        </option>
    </lib-select>
</ng-container>
